import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetInternationalRegistryCurrencyQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;

export type GetInternationalRegistryCurrencyQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    registry?: { __typename?: 'EventData'; id: string; disableIntlRegistry: boolean; currency?: { __typename?: 'RegistryCurrency'; id: string; code: string } | null } | null;
  } | null;
};

export const GetInternationalRegistryCurrencyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetInternationalRegistryCurrency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'disableIntlRegistry' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetInternationalRegistryCurrencyQuery__
 *
 * To run a query within a React component, call `useGetInternationalRegistryCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternationalRegistryCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternationalRegistryCurrencyQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetInternationalRegistryCurrencyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetInternationalRegistryCurrencyQuery, GetInternationalRegistryCurrencyQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetInternationalRegistryCurrencyQuery, GetInternationalRegistryCurrencyQueryVariables>(GetInternationalRegistryCurrencyDocument, baseOptions);
}
export function useGetInternationalRegistryCurrencyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInternationalRegistryCurrencyQuery, GetInternationalRegistryCurrencyQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetInternationalRegistryCurrencyQuery, GetInternationalRegistryCurrencyQueryVariables>(
    GetInternationalRegistryCurrencyDocument,
    baseOptions,
  );
}
export type GetInternationalRegistryCurrencyQueryHookResult = ReturnType<typeof useGetInternationalRegistryCurrencyQuery>;
export type GetInternationalRegistryCurrencyLazyQueryHookResult = ReturnType<typeof useGetInternationalRegistryCurrencyLazyQuery>;
export type GetInternationalRegistryCurrencyQueryResult = Apollo.QueryResult<GetInternationalRegistryCurrencyQuery, GetInternationalRegistryCurrencyQueryVariables>;
